import React from 'react';
import { useTranslation } from 'react-i18next';
import { Maximize2 } from 'lucide-react';
import AvatarIcon from 'Containers/Common/AvatarIcon';
import styles from './CompactClosedChair.module.scss';
import {
  DAY_HEADER_HEIGHT,
  WORKER_HEADER_HEIGHT,
  scaleLayoutPx,
} from '../../constants/layout';

export const COMPACT_CLOSED_CHAIR_WIDTH = 76;

const CompactClosedChair = ({ worker, showHeader, onExpand, zoomScale = 1 }) => {
  const { t } = useTranslation();
  const dayHeaderHeight = scaleLayoutPx(DAY_HEADER_HEIGHT, zoomScale);
  const workerHeaderHeight = scaleLayoutPx(WORKER_HEADER_HEIGHT, zoomScale);
  const chairWidth = scaleLayoutPx(COMPACT_CLOSED_CHAIR_WIDTH, zoomScale, { min: 48 });
  const stickyTop = showHeader ? dayHeaderHeight + 8 : 8;
  const avatarSize = `${scaleLayoutPx(28, zoomScale, { min: 18 })}px`;

  return (
    <div
      className={styles.compact_chair}
      data-compact-chair
      style={{ width: chairWidth, minWidth: chairWidth }}
      aria-label={`${worker.workerName || ''} · ${t('scheduler.closures.closed')}`}
    >
      <div
        className={styles.compact_chair_header}
        style={{
          height: workerHeaderHeight,
          top: showHeader ? dayHeaderHeight : 0,
        }}
      >
        <AvatarIcon icon={worker.icon} name={worker.workerName} size={avatarSize} />
      </div>
      <button
        type="button"
        className={styles.compact_chair_card}
        style={{ top: stickyTop + workerHeaderHeight }}
        onClick={onExpand}
        title={t('scheduler.closures.bookAnyway')}
        aria-label={t('scheduler.closures.expandToBook')}
      >
        <span className={styles.compact_chair_name}>{worker.workerName}</span>
        <span className={styles.compact_chair_status}>{t('scheduler.closures.closed')}</span>
        <span className={styles.compact_chair_action} aria-hidden>
          <Maximize2 size={scaleLayoutPx(14, zoomScale, { min: 10 })} strokeWidth={2.4} />
        </span>
      </button>
    </div>
  );
};

export default CompactClosedChair;
